import { render, staticRenderFns } from "./swedish-validation-errors-modal.vue?vue&type=template&id=95c62206&scoped=true&"
import script from "./swedish-validation-errors-modal.vue?vue&type=script&lang=js&"
export * from "./swedish-validation-errors-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c62206",
  null
  
)

export default component.exports